export const postMailingTemplatesKeys = {
	all: ['postMailingTemplates'],
	list: () => ['postMailingTemplates', 'list'],
	detail: (id) => ['postMailingTemplates', 'detail', id],
};
